module.exports = __webpack_public_path__ + "img/UnityUESceneLinkerModeObjects.a5b3f274.gif";